import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';

import authReducer from 'store/reducers/auth';
import commonReducer from 'store/reducers/common';
import profileReducer from 'store/reducers/profile';
import reportReducer from 'store/reducers/report';
import sampleVideoReducer from 'store/reducers/sample-video';
import surveyReducer from 'store/reducers/survey';
import videoCategoryReducer from 'store/reducers/video-catergory';

const rootReducer = combineReducers({
  auth: authReducer,
  profile: profileReducer,
  common: commonReducer,
  survey: surveyReducer,
  report: reportReducer,
  sampleVideo: sampleVideoReducer,
  videoCategory: videoCategoryReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
